import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from './endpoints';
import { ApiResponse } from 'app/types-shared';
import { ResponsibleForUnitValue } from 'app/area/user-profile/subscriptions/types';
import { SubscriptionWireValue } from 'app/area/user-profile/subscriptions/subscriptions-panel/types';

export const api = {
  getSubscription: () => {
    return new RemoteData(endpoint.loadSubscriptions)
      .resource<ApiResponse<SubscriptionWireValue[]>>()
      .single();
  },

  getSubscriptionOptions: () => {
    return new RemoteData(endpoint.loadSubscriptionOptions)
      .resource<ApiResponse<SubscriptionWireValue[]>>()
      .single();
  },

  saveSubscriptions: async (values: SubscriptionWireValue[]) => {
    return new RemoteData(endpoint.saveSubscriptions)
      .resource<ApiResponse<SubscriptionWireValue[]>>()
      .save(values);
  },

  getResponsibleForUnit: () => {
    return new RemoteData(endpoint.loadResponsibleForUnit)
      .resource<ApiResponse<ResponsibleForUnitValue[]>>()
      .single();
  },

  getAlerts: () => {
    return new RemoteData(endpoint.loadAlerts)
      .resource<ApiResponse<SubscriptionWireValue[]>>()
      .single();
  }
};
